import React from "react";
import { MainLayout } from "../../MainLayout";
import { SouthAfricaSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";

export const SouthAfrica = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/dehi-air.png",
            sliderimg: [
                {
                    id: 1,
                    img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/capetown.webp",
                    title: "Cape Town ",
                },
                {
                    id: 2,
                    img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/winelands.webp",
                    title: "Cape Winelands",
                },
            ],
            title: "4N/5D Cape Town Escape",
            days: "4N/5D",
            tags: ["Sightseeing", "Meals", "AirPort"],
            description:
                "Experience the best of Cape Town with this 5-day, 4-night package featuring stunning landscapes, cultural highlights, and unforgettable adventures. Begin with a half-day city tour, including Table Mountain, followed by a full-day exploration of the scenic Winelands with wine tastings. Discover the breathtaking Cape Peninsula, visiting Cape Point and the famous Penguin Colony. Enjoy comfortable accommodations, daily breakfast, and guided tours, ensuring a seamless and enriching South African getaway.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/dest-itenary1.webp",
            slug: "capeTown",
        },

        {
            title: "5N/6D Cape Town Wonders",
            days: "5N/6D",
            tags: ["Sightseeing", "Meals", "AirPort"],
            description:
                "Discover the beauty of Cape Town with this 6-day, 5-night getaway featuring iconic sights and immersive experiences. Begin with a city tour, exploring landmarks like Table Mountain and the vibrant Bo-Kaap. Enjoy a full-day Winelands tour with wine tastings, followed by an excursion to the Cape Peninsula and Penguin Colony. With a leisure day for relaxation, comfortable accommodations, and guided tours, this package offers the perfect balance of adventure and relaxation.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/kurger.webp",
            slug: "capeTown5",
        },

        {
            title: "4N/5D Johannesburg Heritage Adventure",
            days: "4N/5D",
            tags: ["Sightseeing", "WildLife", "Safari"],
            description:
                "Explore Johannesburg with this 5-day, 4-night adventure, packed with cultural and wildlife experiences. Begin with a full-day Ultimate Johannesburg Tour, visiting historic sites like Constitutional Hill and Soweto. Immerse yourself in South African heritage at the Lesedi Cultural Village, followed by an exhilarating half-day safari at the Lion Park. With comfortable accommodations and guided tours, this trip offers a perfect mix of history, culture, and wildlife.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/trip.webp",
            slug: "Johannesburg",
        },

        {
            title: "3N/4D Sun City Thrill Retreat",
            days: "3N/4D",
            tags: ["Lakes", "Meals", "Sightseeing"],
            description:
                "Enjoy a 4-day escape to Sun City, a premier resort destination filled with adventure and relaxation. Start with a leisurely check-in before diving into a thrilling day at the Valley of Waves water park. Experience the wild side with a 3-hour Pilanesberg Game Drive and an exciting quad biking adventure. With luxurious accommodations and seamless transfers, this trip promises the perfect blend of fun and nature.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/durbans.webp",
            slug: "sunCity",
        },
    ];

    const topcitydata = [
        {
            id: 1, title: "Cape Town", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/South%20africa%20Top%20places/capetown.webp", desc: [
                <p><strong>Why Visit: </strong>Known for its breathtaking scenery, Cape Town is one of the most popular destinations in South Africa. The city is famous for Table Mountain, beautiful beaches, and vibrant neighborhoods. It also offers excellent wine regions and historical sites.</p>,
                <p><strong>Top Attractions: </strong>Table Mountain, Robben Island, V&A Waterfront, Kirstenbosch Botanical Gardens, Cape Point, Boulders Beach (home to penguins), and the District Six Museum.</p>
            ]
        },
        {
            id: 2, title: "Johannesburg (Jo'burg)", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/johannesburg.webp", desc: [
                <p><strong>Why Visit: </strong>Johannesburg is the largest city in South Africa and the economic powerhouse of the country. It’s a city with a rich history, particularly related to the Apartheid era. Johannesburg is known for its vibrant culture, diverse neighborhoods, and proximity to major safari areas.</p>,
                <p><strong>Top Attractions: </strong>Apartheid Museum, Constitution Hill, Gold Reef City, Soweto, Maboneng Precinct, and Walter Sisulu National Botanical Gardens.</p>
            ]
        },
        {
            id: 3, title: "Durban", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/South%20africa%20Top%20places/durban.webp", desc: [
                <p><strong>Why Visit: </strong>Located on the Indian Ocean coast, Durban is known for its warm weather, beautiful beaches, and vibrant Indian culture. It's a popular spot for surfing, beach holidays, and enjoying delicious food, particularly curries.</p>,
                <p><strong>Top Attractions: </strong>Durban Beachfront, uShaka Marine World, Durban Botanical Gardens, Victoria Street Market, and the Moses Mabhida Stadium.</p>
            ]

        },
        {
            id: 4, title: "Pretoria", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/South%20africa%20Top%20places/pretoria.webp", desc: [
                <p><strong>Why Visit: </strong>Pretoria is South Africa's administrative capital and a city full of historical significance. Known for its wide avenues lined with jacaranda trees, Pretoria offers a mix of cultural sites and government buildings.</p>,
                <p><strong>Top Attractions: </strong>Union Buildings, Voortrekker Monument, Kruger House Museum, Pretoria National Botanical Garden, and Freedom Park.</p>
            ]
        },
        {
            id: 5, title: "Port Elizabeth", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Port%20Elizabeth.webp", desc: [
                <p><strong>Why Visit: </strong>Known as the "Friendly City," Port Elizabeth is a coastal city with beautiful beaches, excellent wildlife experiences, and a relaxed atmosphere. It's also the gateway to the famous Addo Elephant Park.</p>,
                <p><strong>Top Attractions: </strong>Addo Elephant National Park, Donkin Reserve, Bayworld Museum, and St. George's Park.</p>
            ]
        },
        {
            id: 6, title: "Stellenbosch", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Stellenbosch.webp", desc: [
                <p><strong>Why Visit: </strong>Located in the heart of the Cape Winelands, Stellenbosch is known for its beautiful vineyards, fine wines, and charming Cape Dutch architecture. It's one of South Africa's oldest towns and offers great food, wine tasting, and cultural experiences.</p>,
                <p><strong>Top Attractions: </strong>Stellenbosch Village Museum, Delaire Graff Estate, Jonkershoek Nature Reserve, and Stellenbosch University.</p>
            ]
        },
        {
            id: 7, title: "Bloemfontein", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/South%20africa%20Top%20places/Bloemfontein.webp", desc: [
                <p><strong>Why Visit: </strong>Bloemfontein, the judicial capital of South Africa, is a quieter, more laid-back city compared to Johannesburg and Cape Town. It’s known for its historical significance and beautiful gardens.</p>,
                <p><strong>Top Attractions: </strong>Naval Hill, Oliewenhuis Art Museum, The National Museum, and Free State National Botanical Garden.</p>
            ]
        },
        {
            id: 8, title: "Nelspruit (Mbombela)", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Nelspruit.webp", desc: [
                <p><strong>Why Visit: </strong>Nelspruit is a popular base for Visiting the Kruger National Park and is located in the scenic Mpumalanga province. It's a city surrounded by stunning nature and offers access to one of Africa's best safari experiences.</p>,
                <p><strong>Top Attractions: </strong>Kruger National Park (nearby), Mbombela Stadium, Sudwala Caves, and Lowveld National Botanical Garden.</p>
            ]
        },
        {
            id: 9, title: "George", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/George.webp", desc: [
                <p><strong>Why Visit: </strong>George is located along the Garden Route, a scenic drive known for its stunning coastal views, lush forests, and charming towns. It's a great place to explore the outdoors and enjoy hiking, beaches, and nature reserves.</p>,
                <p><strong>Top Attractions: </strong>Garden Route National Park, Victoria Bay, Map of Africa Viewpoint, and Cango Caves (nearby).</p>
            ]
        },
        {
            id: 10, title: "Knysna", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/South%20africa%20Top%20places/knysna.webp", desc: [
                <p><strong>Why Visit: </strong>Known for its gorgeous lagoon and coastal beauty, Knysna is a small town along the Garden Route that offers tranquility, nature, and fantastic seafood. It’s perfect for those looking to unwind in a stunning environment.</p>,
                <p><strong>Top Attractions: </strong>Knysna Lagoon, Featherbed Nature Reserve, Knysna Heads, and Knysna Elephant Park.</p>
            ]
        },
        {
            id: 11, title: "Hermanus", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/South%20africa%20Top%20places/Hermanus.webp", desc: [
                <p><strong>Why Visit: </strong>Hermanus is famous for whale watching, particularly from June to November when southern right whales Visit the coastline. It’s a charming seaside town with a relaxed vibe and spectacular views.</p>,
                <p><strong>Top Attractions: </strong>Whale Watching, Gansbaai (Great White Shark cage diving), Fernkloof Nature Reserve, and Hermanus Wine Route.</p>
            ]
        },
        {
            id: 12, title: "Paternoster", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/South%20africa%20Top%20places/Paternoster.webp", desc: [
                <p><strong>Why Visit: </strong>Paternoster is a peaceful coastal village known for its whitewashed cottages and pristine beaches. It's an idyllic destination for those seeking relaxation, seafood, and stunning ocean views.</p>,
                <p><strong>Top Attractions: </strong>Paternoster Beach, Cape Columbine Nature Reserve, and Tietiesbaai.</p>
            ]
        },
        {
            id: 13, title: "Makhado (Louis Trichardt)", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Makhado.webp", desc: [
                <p><strong>Why Visit: </strong>Makhado is a small town located in the Limpopo Province, often visited by travelers on their way to explore the Waterberg or the Kruger National Park. It is known for its lush landscapes and proximity to nature reserves.</p>,
                <p><strong>Top Attractions: </strong>Makhado Nature Reserve, Venda Region, and nearby Willy’s Waterhole.</p>
            ]
        },
        {
            id: 14, title: "Upington", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Upington.webp", desc: [
                <p><strong>Why Visit: </strong>Situated in the Northern Cape, Upington is known for its unique desert landscape, agriculture (particularly for producing some of the country's best wines), and the nearby Kgalagadi Transfrontier Park.</p>,
                <p><strong>Top Attractions: </strong>Kgalagadi Transfrontier Park, Orange River, and Augrabies Falls National Park.</p>
            ]
        },
    ];
    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Custom South Africa Itineraries",
            desc: "Blend cosmopolitan cities like Cape Town with scenic drives, vineyard regions, and Big Five safaris into well-structured, high-value travel programs."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Guided City & Cultural Tours",
            desc: "Offer structured city explorations in Johannesburg and Cape Town, combining history, culture, and contemporary lifestyle with expert-led storytelling."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Luxury Safari Lodges & Reserves",
            desc: "Access top-tier private reserves and lodges with flexible inventory, curated game drives, and inclusions tailored for different client segments."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Scenic Route Programming",
            desc: "Use the Garden Route as the core itinerary backbone, integrating coastal drives, boutique stays, and activity-led stopovers for enriched travel flow."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Adventure Experiences Add-Ons",
            desc: "Enhance itineraries with high-demand activities like shark cage diving, whale watching, and hiking at Table Mountain."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Wine & Culinary Experiences",
            desc: "Build premium experiences across Stellenbosch and Franschhoek with private tastings, vineyard tours, and curated dining for upscale travelers."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Beach & Coastal Escapes",
            desc: "Position Durban and the Cape coastline as ideal add-ons for relaxation within longer itineraries."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "End-to-End Ground Handling",
            desc: "Ensure smooth execution with reliable transport, approved accommodations, and on-ground coordination designed for consistency and scalability."
        },
    ];
    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/South%20Africa.webp")'}
                text2={"South Africa"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={SouthAfricaSec1Data} />
               <IndiaSec2 countryCode="ZA" />
            <IndiaSec3 data={topcitydata} name={"SouthAfrica"} />
            <IndiaSec4 data={data}
                heading={"Discover What We Bring to South Africa "}
            />
            <Footer />

        </>
    )


};